import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import {AddReactionIcon} from '../../icon/svg/add-reaction-icon';
import {Popover} from '../../popover/popover';

import {REACTIONS} from './consts';
import type {Reaction} from './types';

import styles from './add-reaction-button.module.css';

type Props = {
    onSelectReaction: (selectedReaction: Reaction) => any;
};

export function AddReactionButton(props: Props) {
    const [showPopover, setShowPopover] = React.useState<boolean>(false);

    const addButtonRef = React.useRef(undefined);

    function togglePopover() {
        setShowPopover((prevState) => !prevState);
    }

    React.useEffect(() => {
        ReactTooltip.rebuild();

        return () => ReactTooltip.hide();
    }, []);

    return (
        <>
            {showPopover ? (
                <Popover
                    anchor={addButtonRef ? addButtonRef.current : undefined}
                    location='top'
                    onBlur={togglePopover}
                >
                    <div className={styles['reaction-selection-popover']}>
                        {/* @ts-expect-error */}
                        {Object.keys(REACTIONS).map((reaction: Reaction) => (
                            <button
                                key={reaction}
                                // @ts-expect-error
                                title={REACTIONS[reaction].label}
                                onClick={() => {
                                    props.onSelectReaction(reaction);
                                    setShowPopover(false);
                                }}
                                className={styles['reaction-button']}
                            >
                                {/* @ts-expect-error */}
                                {REACTIONS[reaction].unicode}
                            </button>
                        ))}
                    </div>
                </Popover>
            ) : undefined}
            <button
                // @ts-expect-error
                ref={addButtonRef}
                data-tip='Add reaction'
                onClick={togglePopover}
                className={
                    showPopover
                        ? styles['add-reaction-button--active']
                        : styles['add-reaction-button']
                }
            >
                <AddReactionIcon size={15} />
            </button>
        </>
    );
}
